<template>
  <div class="app-setting-container" v-loading="loading">
    <div v-if="!loading" class="app-setting-body">
      <div class="content">
        <el-form
          class="custom-success-input"
          label-position="left"
          :inline="true"
          ref="appSetting"
          :model="formData"
          @submit.native.prevent
        >
          <!-- 没有生成app -->
          <div v-if="isFirstInto" class="first-into">
            <div class="content">
              <div class="app-name">
                <el-form-item
                  prop="appName"
                  :rules="[{ required: true, message: '请输入app名称', trigger: 'blur' }]"
                >
                  <div>
                    <span class="custom-label" slot="label">名称</span>
                  </div>
                  <el-input v-model="formData.appName" clearable></el-input>
                </el-form-item>
              </div>
              <!-- 图标 -->
              <div class="app-icon">
                <el-form-item>
                  <div>
                    <span class="custom-label" slot="label">图标</span>
                    <image-upload :images.sync="formData.appIcon"></image-upload>
                  </div>
                </el-form-item>
              </div>
              <!-- 启动图 -->
              <div class="start-iamge">
                <el-form-item>
                  <div>
                    <span class="custom-label" slot="label">启动图</span>
                    <image-upload :images.sync="formData.appImageWelcome"></image-upload>
                  </div>
                </el-form-item>
              </div>
              <!-- 广告图 -->
              <div class="advertising-iamge">
                <el-form-item>
                  <div>
                    <span class="custom-label" slot="label">广告页</span>
                    <image-upload
                      :images.sync="formData.appImageAdvertises"
                      :isMulti="true"
                      :limit="5"
                    ></image-upload>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="footer">
              <el-button type="primary" @click="saveApp(true)">一键生成</el-button>
            </div>
          </div>
          <!-- 生成了app之后 -->
          <div v-else class="again-into">
            <div class="title">
              <div class="content">
                <image-upload :images.sync="formData.appIcon" @uploadSucess="saveApp(false)"></image-upload>
                <div class="info">
                  <div class="app-name">
                    <el-form-item
                      label="应用名称："
                      prop="appName"
                      :rules="[{ required: true, message: '请输入app名称', trigger: 'blur' }]"
                    >
                      <div v-if="isEditName" class="name">
                        <span>{{ formData.appName }}</span>
                        <el-button type="text" class="el-icon-edit-outline" @click="isEditName = false"></el-button>
                      </div>
                      <div v-else class="edit-name">
                        <el-input placeholder="请输入app名称" v-model="formData.appName" clearable>
                          <el-button slot="append" icon="el-icon-check" @click="saveName"></el-button>
                        </el-input>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="create-timer">
                    <span>创建时间：{{ formData.createTime }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="qr-code">
              <div class="content">
                <div class="item">
                  <div class="name">
                    <span>IOS({{ formData.iosVersion }})</span>
                  </div>
                  <div class="image">
                    <img :src="formData.appQrCode" alt>
                  </div>
                  <div class="operation">
                    <el-button type="primary" @click="newCreate(0)" :disabled="isNewCreate[0]">重新生成</el-button>
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    <span>Android({{ formData.androidVersion }})</span>
                  </div>
                  <div class="image">
                    <img :src="formData.appQrCode" alt>
                  </div>
                  <div class="operation">
                    <el-button type="primary" @click="newCreate(1)" :disabled="isNewCreate[1]">重新生成</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import imageUpload from '../image-upload'
export default {
  name: 'appSetting',
  components: {
    imageUpload
  },
  data () {
    return {
      isFirstInto: true,
      formData: {
        appIcon: '',
        appImageWelcome: '',
        appImageAdvertises: []
      },
      dialogImageUrl: '',
      dialogVisible: false,
      headers: '',
      isEditName: true,
      appId: '',
      loading: true,
      isNewCreate: [false, false]
    }
  },
  methods: {
    // 判断是否生成过APP
    judgeIsCreateApp () {
      return new Promise(resolve => {
        this.$axios.get('/mobile-api/design?').then(res => {
          res.data.length > 0 && (this.appId = res.data[0])
          this.$nextTick(() => resolve())
        })
      })
    },
    // 保存修改
    saveName () {
      this.$refs.appSetting.validateField('appName', (error, fiels) => {
        if (error === '') {
          this.isEditName = true
          this.saveApp(false)
        }
      })
    },
    getAppDetails (id) {
      return new Promise(resolve => {
        this.$axios.get(`/mobile-api/design/${id}`).then(res => {
          this.isFirstInto = false
          res.data && resolve(res.data)
        })
      })
    },
    saveApp (flag) {
      this.$refs.appSetting.validate(v => {
        if (v) {
          let params = {...this.formData}
          params.appImageAdvertises = params.appImageAdvertises.join('$')
          this.appId && (params.id = this.appId)
          params.rootUrl = `${window.location.protocol}//${window.location.host}`
          this.$axios.post(`/mobile-api/design?${this.appId}`, params).then(res => {
            flag && this.$message({
              message: '生成成功',
              type: 'success'
            })
            this.getAppDetails(this.appId)
          })
        }
      })
    },
    // 重新生成 0: ios 1: android
    newCreate (flag) {
      this.$axios.get(`/mobile-api/design/appPackage?id=${this.appId}&androidFlag=${flag === 0 ? 0 : 1}&iosFlag=${flag === 1 ? 0 : 1}`).then(res => {
        this.$message({
          message: '重新生成成功，正在打包',
          type: 'warning'
        })
        this.$set(this.isNewCreate, flag, true)
      })
    }
  },
  created () {
    this.judgeIsCreateApp().then(res => {
      // res有值代表不是第一次进入
      if (this.appId) return this.getAppDetails(this.appId)
      else {
        this.loading = false
        return null
      }
    }).then(res => {
      if (res !== null) {
        this.loading = false
        this.formData = res
        this.formData.appImageAdvertises = res.appImageAdvertises.split('$')
      }
    })
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";
  .app-setting-container {
    height: 100%;
    padding: 10px;

    div,
    span,
    p,
    label {
      font-size: 12px;
    }

    .app-setting-body {
      background: #fff;
      box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
      border-radius: 4px 0;
      height: 100%;

      .content {
        height: 100%;

        .el-form {
          height: 100%;

          .first-into {
            padding: 80px 10px 10px 200px;
            height: 100%;
            overflow: auto;

            .content {
              height: calc(100% - 100px);
            }

            .footer {
              text-align: center;
              padding-bottom: 20px;
              margin: 0 auto;
            }
          }

          .again-into {
            width: 100%;

            .title {
              width: 100%;
              padding: 40px 0;
              border-bottom: 1px dashed #d9d9d9;

              .content {
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                width: 360px;
                margin: 0 auto;

                .info {
                  margin-left: 20px;
                  padding: 16px 0;

                  .create-timer {
                    padding-left: 4px;
                  }

                  & > .app-name {
                    height: 46px;
                  }

                  .name {
                    .el-icon-edit-outline {
                      margin-left: 20px;
                    }
                  }

                  .el-form-item__label {
                    padding: 0;
                  }

                  .el-input {
                    width: 100px;

                    .el-input__inner {
                      width: 131px;
                    }
                  }

                  .el-input-group__append {
                    background-color: #55acf1;
                    border-color: #55acf1;
                    color: #fff;
                    padding: 0 12px;
                  }
                }
              }
            }

            .qr-code {
              width: 100%;
              height: 100%;

              .content {
                width: 500px;
                height: 100%;
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                margin: 0 auto;
                padding-top: 50px;

                .item {
                  width: 180px;
                  margin-right: 100px;

                  .name {
                    margin-bottom: 20px;
                    text-align: center;
                  }

                  .image {
                    width: 180px;
                    height: 180px;

                    img {
                      width: 100%;
                      height: 100%;
                    }
                  }

                  .operation {
                    margin-top: 20px;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/appDesign/app-setting.vue